import React from 'react';
import {
  Alert,
  Heading,
  FlexWrapper,
  Input,
  SPACINGS,
  Button,
  ActionText,
  useMediaQuery,
  useTheme,
  Card,
} from '@qadra/frontend-common-ts';
import { useForm, queryString, yup, yupResolver } from '@qadra/frontend-common';
import { useTranslate } from '@federico.moretti/react-translate';
import { useDispatch, useSelector } from '@qadra/frontend-common/redux/hooks';
import { useLocation } from '@qadra/frontend-common/router';
import { LOGIN } from '../redux/actions';
import { paths } from '../utils';
import { profilingCardStyle } from './styles';
import { MobileButtonContainer, MobileContainer } from './mobileStyles';
import { ClientConfigContext } from '../contexts/ClientConfigContext';

const schema = yup.object().shape({
  Username: yup.string().email('emailNotValid').required('emailRequired'),
  Password: yup.string().required('passwordRequired'),
});

function Login() {
  const dispatch = useDispatch();
  const { t } = useTranslate();
  const error = useSelector((s) => s.login.error);
  const location = useLocation();
  const theme = useTheme();

  const { register, handleSubmit, errors } = useForm({ resolver: yupResolver(schema) });

  function login({ Username, Password }) {
    const { ReturnUrl, DevReturnUrl } = queryString.parse(location.search);
    dispatch({
      type: LOGIN._REQUEST,
      payload: { Username, Password, ReturnUrl, DevReturnUrl },
    });
  }

  const isMobile = useMediaQuery(theme.mediaQueries.isMobile);

  const clientConfig = React.useContext(ClientConfigContext) || {};
  const bgColor = clientConfig.bgColor || theme.colors.primary;

  if (isMobile)
    return (
      <>
        <form style={{ width: '100%' }} onSubmit={handleSubmit(login)}>
          <MobileContainer>
            <Heading
              style={{ marginTop: SPACINGS[8], marginBottom: SPACINGS[20] }}
              align="center"
              type={3}
            >
              {t('sso.login.title')}
            </Heading>
            {error && (
              <Alert style={{ marginBottom: SPACINGS[8] }} type="danger">
                {error}
              </Alert>
            )}
            <Input
              initialIsLabelUp
              label={t('email')}
              inputRef={register}
              style={{ width: '100%', marginBottom: SPACINGS[4] }}
              name="Username"
              error={errors?.Username && t(`errors.${errors.Username.message}`)}
            />
            <Input
              initialIsLabelUp
              label={t('password')}
              type="password"
              inputRef={register}
              style={{ width: '100%', marginBottom: SPACINGS[6] }}
              name="Password"
              error={errors?.Password && t(`errors.${errors.Password.message}`)}
            />
            <ActionText
              display="block"
              size="sm"
              transform="none"
              margin="none"
              type="link"
              align="center"
              to={paths.forgotPassword}
            >
              {t('sso.login.passForgot')}
            </ActionText>
            <MobileButtonContainer>
              <Button size="lg" type="submit" style={{ backgroundColor: bgColor, borderColor: bgColor }}>
                {t('sso.login.loginLabel')}
              </Button>
            </MobileButtonContainer>
          </MobileContainer>  
        </form>
      </>
    );

  return (
    <>
      {error && (
        <Alert
          type="danger"
          style={{ marginBottom: SPACINGS[12], width: theme.dimensions.maxCardWidth }}
        >
          {error}
        </Alert>
      )}
      <form onSubmit={handleSubmit(login)}>
        <FlexWrapper direction="column">
          <Card style={profilingCardStyle(theme)}>
            <FlexWrapper direction="column" justify="flex-start">
              <Heading align="center" type={2} style={{ marginBottom: SPACINGS[12] }}>
                {t('sso.login.title')}
              </Heading>
              <FlexWrapper direction="column">
                <Input
                  initialIsLabelUp
                  label={t('email')}
                  inputRef={register}
                  style={{ marginBottom: SPACINGS[4] }}
                  name="Username"
                  error={errors?.Username && t(`errors.${errors.Username.message}`)}
                />
                <Input
                  initialIsLabelUp
                  label={t('password')}
                  type="password"
                  inputRef={register}
                  style={{ marginBottom: SPACINGS[6] }}
                  name="Password"
                  error={errors?.Password && t(`errors.${errors.Password.message}`)}
                />
                <ActionText
                  display="block"
                  transform="none"
                  margin="none"
                  type="link"
                  align="center"
                  to={paths.forgotPassword}
                >
                  {t('sso.login.passForgot')}
                </ActionText>
        
              </FlexWrapper>
              <div style={{marginTop: SPACINGS[30]}}>
                <Button type="submit" style={{width: '300px', backgroundColor: bgColor, borderColor: bgColor}}>{t('sso.login.loginLabel')}</Button>
              </div>
            </FlexWrapper>
          </Card>
        </FlexWrapper>
      </form>
    </>
  );
}

export default Login;
